import './CallToActionBanner.scss';
import sendEvent from '../../helpers/tracking';
import { setItem } from '../../helpers/localStorage';

import Alarm from '../../shared/assets/icons/alarm.svg';

export default function CallToActionBanner(props) {
  const {
    title,
    color,
    background,
    buttonLink,
    buttonLabel,
    withoutIcon,
    actionTitleMobile,
    actionTitleDesktop,
    eventTrackingCodes
  } = props;

  return (
    <section
      id="callToAction"
      style={{
        ...(color && { color }),
        ...(background && { backgroundColor: background })
      }}
    >
      {props.title && (
        <div id="callToAction_title">
          <p>{title}</p>
        </div>
      )}

      <div id="callToAction_content">
        <p className="callToAction_desktop">{actionTitleDesktop}</p>

        <div className="callToAction_mobile">
          <p>{actionTitleMobile[0]}</p>
          <p>{actionTitleMobile[1]}</p>
        </div>

        <button
          id="callToAction_button"
          onClick={() => {
            if (eventTrackingCodes) sendEvent(...eventTrackingCodes);

            setItem('originalUrl', '/dashboard');

            location.href = buttonLink;
          }}
          style={{ ...(color && { borderColor: color }) }}
        >
          {buttonLabel} {!withoutIcon && <Alarm />}
        </button>
      </div>
    </section>
  );
}
